import { render, staticRenderFns } from "./menopauseindicator.vue?vue&type=template&id=65b2f94c&scoped=true&"
import script from "./menopauseindicator.vue?vue&type=script&lang=js&"
export * from "./menopauseindicator.vue?vue&type=script&lang=js&"
import style0 from "./menopauseindicator.vue?vue&type=style&index=0&id=65b2f94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2f94c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b2f94c')) {
      api.createRecord('65b2f94c', component.options)
    } else {
      api.reload('65b2f94c', component.options)
    }
    module.hot.accept("./menopauseindicator.vue?vue&type=template&id=65b2f94c&scoped=true&", function () {
      api.rerender('65b2f94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopauseindicator.vue"
export default component.exports